import React from 'react';
import {MainLayout} from 'components/layouts';
import {HomeBannerForm} from 'components/home-banners';
import {HomeBanners} from 'base/api';
import {toastr} from 'react-redux-toastr';

class AddHomeBanner extends React.Component {
  constructor(props, context) {
    super(props, context);

  }
  cb(response) {
    // Back to home banners list
    toastr.success('Thành công!', 'Danh mục đã được thêm thành công.');

    this.props.history.push('/home-banners');
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className="register-logo">
            <b>Thêm mới banner</b>
          </div>
          <HomeBannerForm fnSubmit={HomeBanners.actions.add} cb={this.cb.bind(this)}/>
        </div>
      </MainLayout>
    );
  }
}

AddHomeBanner.contextTypes = {
  router: React.PropTypes.object
};

export default AddHomeBanner;



// WEBPACK FOOTER //
// ./pages/home-banners/Add.jsx